import { useState, useEffect } from "react";
import {
  Container,
  Box,
  Grid,
  Button,
  Typography,
  //   Box,
  //   Typography,
  //   TextField,

  //   Grid,
  //   Card,
  //   CardActions,
  //   CardContent,
  //   FormGroup,
} from "@mui/material";
// import { BodyInfoApi } from "../api/BodyInfoApi";
import { MemberApi } from "../api/MemberApi";
import { useSelector, useDispatch } from "react-redux";
import { memberID, updateAuthState } from "../reducers/userSlice";
import { removeLocalStorageUser } from "../helper/LocalStorageHelper";
import HealthInfoList from "../components/HealthInfoList";

export default function Page() {
  const dispatch = useDispatch();
  const [infoList, setInfoList] = useState([]);
  // const [eventList, setEventList] = useState([]);

  const currentMemberID = useSelector(memberID);

  const loadDataList = async () => {
    if (currentMemberID === null) {
      return;
    }
    //console.debug("currentMemberID: ", currentMemberID);
    const result = await MemberApi.getEventHealthInfo(currentMemberID);
    console.debug("result: ", result);
    setInfoList(result);
  };

  useEffect(() => {
    loadDataList();
  }, [currentMemberID]);



  return (
    <Box>
      <HealthInfoList infoList={infoList}>
      </HealthInfoList>
    </Box>
  );
}
